
import React, { useEffect, useState } from 'react';
import { getShowcaseImageUrls } from '../services/supabase';
import './Showcase.css';


const Showcase: React.FC = () => {
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      setError('');
      try {
        const urls = await getShowcaseImageUrls();
        setImageUrls(urls);
      } catch (err: any) {
        setError('Failed to load showcase images.');
        console.error('[Showcase] Error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  return (
    <section className="showcase">
      <div className="container">
        <h2 className="section-title">Showcase of Our Work</h2>
        {loading ? (
          <div className="loading">Loading showcase...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : (
          <div className="showcase-grid">
            {imageUrls.length === 0 ? (
              <div className="error-message">No showcase images found.</div>
            ) : (
              imageUrls.map((url, idx) => (
                <div className="showcase-card" key={url}>
                  <img src={url} alt={`Showcase ${idx + 1}`} className="showcase-image" />
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default Showcase;
